import React, { Component } from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import { Security,SecureRoute, ImplicitCallback } from '@okta/okta-react';
import Home from './Pages/Home';
import Login  from './Login/Login'
import NewReport from './Pages/supplier/newreport'
// import ResinData from './Pages/supplier/ResinData'
import VRNotifications from './Pages/supplier/VRNotifications'
import FAIRNotifications from './Pages/supplier/FAIRNotifications'

import CreateReport from './Pages/supplier/CreateReport'
import UploadCreate from './Pages/supplier/upolad_create_report'
import UploadReport from './Pages/supplier/upolad_report'
import TemplateDownload from './Pages/supplier/template_download'
import GenerateToken from './Pages/supplier/generate_token'

import Analytics from './Pages/analytics'
import MainPage from './Pages/supplier/LandingPage'
import LandingPage from './Pages/supplier/'
import './App.css';
import config from './config/okta.config';
import errorPage from './Pages/servererror'
import { ApolloProvider } from '@apollo/react-hooks';
import { StateProvider } from './reducers/state';
import {reducer, initialState} from './reducers/reducer'
import { ApolloClient } from 'apollo-client';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { HttpLink } from 'apollo-link-http';
import { onError } from 'apollo-link-error';
import { ApolloLink } from 'apollo-link';
import { createBrowserHistory } from 'history';



const history = createBrowserHistory();


const authMiddleware = new ApolloLink((operation, forward) => {
  // add the authorization to the headers
  const token = JSON.parse(localStorage.getItem('okta-token-storage')).accessToken.accessToken;
  operation.setContext(({ headers = {} }) => ({
    headers: {
      authorization: token || null,
      authVendorID: localStorage.getItem('loggedInVendor')
    }
  }));

  return forward(operation);
})

const client = new ApolloClient({
  link: ApolloLink.from([authMiddleware,
    onError(({ graphQLErrors, networkError }) => {
      if (graphQLErrors)
        graphQLErrors.forEach(({ message, locations, path }) => {
       
          console.log(
            `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`,
          )
          // showErrorPage();

        }
        );
      if (networkError) {
        console.log(`[Network error]: ${networkError}`);
        // showErrorPage();
      }
    }),
    new HttpLink({
      uri: "/graphql",
      credentials: 'same-origin'
    })
  ]),
  cache: new InMemoryCache()
});

function onAuthRequired({history}) {
  history.push('/login');
}

const showErrorPage = () => {
  history.push('/supplier/servererror');
  history.go();
  
}



class App extends Component {
  
  render() {
    return (
      <ApolloProvider client={client}>
  <StateProvider initialState={initialState} reducer={reducer}>
      <Router>
      <Security issuer={config[window.location.hostname].issuer}
          client_id={config[window.location.hostname].client_id}
          redirect_uri={config[window.location.hostname].redirect_uri}
          scopes={['openid','profile','groups','email']}
          redirectUri={config[window.location.hostname].redirectUri}
          onAuthRequired={onAuthRequired}>
          <SecureRoute path='/' exact={true} component={Home}/>
          <SecureRoute path='/supplier/' component={LandingPage}/>
          <SecureRoute path='/supplier/LandingPage' component={MainPage}/>
          <SecureRoute path='/supplier/upload_create' component={UploadCreate}/>
          <SecureRoute path='/supplier/upload_report' component={UploadReport}/>
          <SecureRoute path='/supplier/template_download' component={TemplateDownload}/>
          <SecureRoute path='/supplier/newreport' component={NewReport} />
          <SecureRoute path='/supplier/generate_token' component={GenerateToken}/>

          {/* <SecureRoute path='/supplier/resin_data' component={ResinData} /> */}
          {/* <SecureRoute path='/supplier/VRNotifications' component={VRNotifications} />
          <SecureRoute path='/supplier/FAIRNotifications' component={FAIRNotifications} /> */}

          <SecureRoute path='/supplier/createreport' component={CreateReport} />
          <SecureRoute path='/supplier/servererror' component={errorPage}/>
          <Route path='/login' render={() => <Login baseUrl={config[window.location.hostname].issuer} />} />
          <Route path='/implicit/callback' component={ImplicitCallback}/>
          
        </Security>
      </Router>
      </StateProvider>
          </ApolloProvider>

    );
  }
}
export default App;
